// extracted by mini-css-extract-plugin
export default {"venueList":"VenueList_venueList__k1Bf4","title":"VenueList_title__1O5YF","addNew":"VenueList_addNew__hbQVa"};